var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"message-thread__reaction"},[_c('v-icon',{attrs:{"icon":"favorite"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }